// antd の message に関する設定です。
const messageConfig = {
  // エラーメッセージの表示時間（秒）です。
  // メッセージにはユーザーが次に何をすべきかが書かれているため、
  // ユーザーがメッセージを読むのに十分な時間を設定します。
  ERROR_DURATION: 10,
};

export { messageConfig };
